exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".bg-color-primary {\n    background: #f44336;\n}\n\n.bg-light-blue {\n    background: hsl(202, 87%, 71%)\n}\n\n.bg-color-orange {\n    background: rgb(255, 152, 0);\n}\n\n.bg-color-green {\n    background: rgb(0, 150, 136);\n}\n\n.grow {\n    z-index: 9998;\n    -webkit-transition: all .2s ease-out;\n    transition: all .2s ease-out;\n}\n\n.grow:hover {\n    z-index: 9999;\n    -webkit-transform: scale(1.6);\n            transform: scale(1.6);\n}", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// P:/Portfolio-angular-master/src/app/top/cards/cards.component.css
// module id = ../../../../../src/app/top/cards/cards.component.css
// module chunks = main